import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from '@bugsnag/js'
import VuePlugin from '@bugsnag/plugin-vue'

const isEnabled = (key = import.meta.env.VITE_BUGSNAG_API_KEY) => !!key

export function startBugsnag() {
  if (isEnabled()) {
    const version = {
      appVersion: import.meta.env.VITE_BUILDVERSION ?? '0.0.0-dev',
      releaseStage: import.meta.env.VITE_RELEASE_STAGE,
    }

    // eslint-disable-next-line no-console
    console.log('Bugsnag enabled', version)
    Bugsnag.start({
      apiKey: import.meta.env.VITE_BUGSNAG_API_KEY!,
      ...version,
      plugins: [new VuePlugin()],
    })
    BugsnagPerformance.start({ apiKey: import.meta.env.VITE_BUGSNAG_API_KEY })
  }

  return Bugsnag
}

function bugsnagProxy<T extends (...args: any[]) => any>(fn: T, dv?: any): T {
  return function (...args: any[]) {
    if (isEnabled())
      return fn(...args)

    return dv
  } as any
}

export const getPlugin = bugsnagProxy(Bugsnag.getPlugin, () => null)
export const notify = bugsnagProxy(Bugsnag.notify)
export const setUser = bugsnagProxy(Bugsnag.setUser)
export const addMetadata = bugsnagProxy(Bugsnag.addMetadata)
